<template>
  <div class="flex flex-col gap-3">
    <p v-if="loading && !lists.length" class="text-sm text-gray-500">
      {{ $t('CONTACT_PROFILE.LISTS_TAB.LOADING') }}
    </p>
    <p v-else-if="failed" class="text-sm text-red-600">
      {{ $t('CONTACT_PROFILE.LISTS_TAB.ERROR') }}
    </p>
    <p v-else-if="!lists.length" class="text-sm text-gray-500">
      {{ $t('CONTACT_PROFILE.LISTS_TAB.EMPTY') }}
    </p>
    <ul
      v-else
      class="flex flex-col m-0 p-0 list-none border border-solid border-gray-200 rounded-lg divide-y divide-gray-100"
    >
      <li v-for="list in lists" :key="list.id" class="px-4 py-3">
        <router-link
          :to="{
            name: 'list_members',
            params: { accountId: $route.params.accountId, id: list.id },
          }"
          class="text-sm text-gray-800 hover:text-brand"
          dir="auto"
        >
          {{ list.name }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import ListsAPI from 'dashboard/api/lists';

const MAX_LISTS = 100;

export default {
  props: {
    contactId: {
      type: [String, Number],
      required: true,
    },
    refreshKey: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return { lists: [], loading: false, failed: false, requestId: 0 };
  },
  watch: {
    contactId: 'fetchLists',
    refreshKey: 'fetchLists',
  },
  mounted() {
    this.fetchLists();
  },
  methods: {
    async fetchLists() {
      this.requestId += 1;
      const requestId = this.requestId;
      this.loading = true;
      try {
        const {
          data: { payload = [] },
        } = await ListsAPI.get(1, {
          contact_id: this.contactId,
          per_page: MAX_LISTS,
        });
        if (requestId === this.requestId) {
          this.lists = payload;
          this.failed = false;
        }
      } catch (error) {
        if (requestId === this.requestId) {
          this.lists = [];
          this.failed = true;
        }
      } finally {
        if (requestId === this.requestId) this.loading = false;
      }
    },
  },
};
</script>
